import { getDictItemApi } from "@/api/api";
/**
 * 获取字典列表
 * @param {codeParent} codeParent 字典code
 * @return {data} 查询结果
 */
export async function getDictItem(codeParent) {
  const res = await getDictItemApi({ data: { codeParent } });
  return res.data;
}

export function getDictValue(dictList, code) {
  const dict = dictList.find(item => {
    return item.code == code;
  });
  return dict;
}

export function getDictValueByCodeText(dictList, codeText) {
  const dict = dictList.find(item => {
    return item.codeText == codeText;
  });
  return dict?.value;
}
